











































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class FAQs extends Vue {
  breadcrumbItems: any = [
    {
      text: 'Home',
      href: '/'
    },
    {
      text: 'FAQs',
      href: '#'
    }
  ];
}
